import IconButton from "@mui/material/IconButton";
import React, {useEffect, useState} from "react";
import { Link } from "react-router-dom";

import NotificationsIcon from "@mui/icons-material/Notifications";
import { Typography } from "@mui/material";
import Badge from "@mui/material/Badge";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { createDatesFromTimeFrame } from "../../core/date";
import config from "../../envconfig";
import useGetApiImports from "../../hooks/useGetApiImports";
import useGetUnreportedCount from "../../hooks/useGetUnreportedCount";
import { actions as advActions } from "../advertising/logic/formActions";
import { Paths } from "./navigation";

const unReportedCountTimeFrame = config.PERIOD_CHECK_UNREPORTED_IN_DAYS;

const NotificationBell = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { filmsNoAccepted } = useGetApiImports();
    const [unReportInitialDate, setUnReportInitialDate] = useState(new Date());
    const { unreportedCount } = useGetUnreportedCount({
        refetchInterval: 1,
        timeFrameInDays: unReportedCountTimeFrame,
        initialDate: unReportInitialDate
    });
    const [anchorNotifications, setAnchorNotifications] = React.useState(null);
    const openNotification = Boolean(anchorNotifications);
    function hanldeOpenNotifications(event) {
        setAnchorNotifications(event.currentTarget);
    }

    function closeNotifications() {
        setAnchorNotifications(null);
    }

    const handleClickUnreported = () => {
        closeNotifications();

        const { futureDate: today, pastDate: fiveDaysAgo } = createDatesFromTimeFrame(unReportedCountTimeFrame);
        const params = [
            {
                attribute: "advReported",
                value: false,
            },
            {
                attribute: "advEnteredDateStart",
                value: fiveDaysAgo.toISOString(),
            },
            {
                attribute: "advEnteredDateEnd",
                value: today.toISOString(),
            },
        ];
        dispatch(advActions.CHANGE_FORM.send(params));
        navigate(Paths.ADVERTISING);
    };
    return (
        <>
            <IconButton color="inherit" onClick={hanldeOpenNotifications}>
                <Badge
                    badgeContent={filmsNoAccepted || unreportedCount}
                    color={filmsNoAccepted > 0 ? "error" : "secondary"}
                >
                    <NotificationsIcon />
                </Badge>
            </IconButton>

            {(filmsNoAccepted > 0 || unreportedCount > 0) && (
                <Menu
                    elevation={1}
                    id={"notification_menu"}
                    anchorEl={anchorNotifications}
                    anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "right",
                    }}
                    keepMounted
                    transformOrigin={{
                        vertical: "top",
                        horizontal: "right",
                    }}
                    open={openNotification}
                    onClose={closeNotifications}
                >
                    {unreportedCount > 0 && (
                        <ItemFromMenu onClick={handleClickUnreported}>
                            <Typography
                                style={{ textDecoration: "unset", color: "initial", marginRight: "25px" }}
                                to={Paths.ADMIN_API_IMPORT}
                            >
                                Unreported
                            </Typography>
                            <Badge
                                style={{ paddingLeft: "10px", display: "inline-block" }}
                                anchorOrigin={{
                                    vertical: "bottom",
                                    horizontal: "left",
                                }}
                                badgeContent={unreportedCount}
                                color="secondary"
                            />
                        </ItemFromMenu>
                    )}

                    {filmsNoAccepted > 0 && (
                        <ItemFromMenu onClick={closeNotifications}>
                            <Link
                                style={{ textDecoration: "unset", color: "initial", marginRight: "22px" }}
                                to={Paths.ADMIN_API_IMPORT}
                            >
                                API Import
                            </Link>
                            <Badge
                                style={{ paddingLeft: "10px", display: "inline-block" }}
                                anchorOrigin={{
                                    vertical: "bottom",
                                    horizontal: "left",
                                }}
                                badgeContent={filmsNoAccepted}
                                color="error"
                            />
                        </ItemFromMenu>
                    )}
                </Menu>
            )}
        </>
    );
};

export default NotificationBell;

const ItemFromMenu = ({ children, ...props }) => {
    return (
        <MenuItem
            style={{
                display: "flex",
                justifyContent: "space-between",
            }}
            {...props}
        >
            {children}
        </MenuItem>
    );
};

ItemFromMenu.propTypes = {
    children: PropTypes.node,
};
